<template>
  <div class="switch-green-selected" :class="className">
    <div v-bind:key="i" v-for="(option, i) in options">    
      <vs-tooltip v-if="truncatedText(option.text, false)">
        <div
          class="b-simple"
          :class="{
            active: value == option.id,
            'disabled-option':option.disabled,
            'hide-variant':option.hideUnavailableVariant && option.disabled 
          }"
         @click="onSwitch(option.id)"
        >
          <div class="b-simple__content">
            <div v-if="option.imgSrc" class="b-simple__content__image">
              <img
                :src="option.imgSrc"
                class="courier-img icon"
                width="24px"
                height="24px"
                alt=""
                style="margin-right: 10px"
              />
            </div>
            <p class="b-simple__content__title">{{ truncatedText(option.text) }}</p>
          </div>
          <img
            v-if="value == option.id"
            class="b-simple__mark"
            src="@/assets/icons/blue-tick.svg"
            id="voicebutton"
          />
        </div>
        <template #tooltip>
          {{ option.text }}
        </template>
      </vs-tooltip>

      <div
        class="b-simple"
        :class="{
          active: value == option.id,
          'disabled-option':option.disabled,
          'hide-variant':option.hideUnavailableVariant && option.disabled        
        }"
        @click="onSwitch(option.id)"
      >
        <div class="b-simple__content">
          <div v-if="option.imgSrc" class="b-simple__content__image">
            <img
              :src="option.imgSrc"
              class="courier-img icon"
              width="24px"
              height="24px"
              alt=""
              style="margin-right: 10px"
            />
          </div>
          <p class="b-simple__content__title">{{ option.text }}</p>
        </div>
        <svg v-if="value == option.id" class="b-simple__mark" width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect y="0.488037" width="16" height="16" rx="8" fill="white"/>
          <path fill-rule="evenodd" clip-rule="evenodd" d="M1.6001 8.48801C1.6001 4.95339 4.46548 2.08801 8.0001 2.08801C11.5347 2.08801 14.4001 4.95339 14.4001 8.48801C14.4001 12.0226 11.5347 14.888 8.0001 14.888C4.46548 14.888 1.6001 12.0226 1.6001 8.48801ZM11.3658 7.4537C11.6782 7.14128 11.6782 6.63475 11.3658 6.32233C11.0534 6.00991 10.5468 6.00991 10.2344 6.32233L7.2001 9.35664L6.16578 8.32233C5.85336 8.00991 5.34683 8.00991 5.03441 8.32233C4.72199 8.63475 4.72199 9.14128 5.03441 9.4537L6.63441 11.0537C6.94683 11.3661 7.45336 11.3661 7.76578 11.0537L11.3658 7.4537Z" fill="#14AD4D"/>
        </svg>

      </div>
      
    </div>
  </div>
</template>

<script>
import config from "./../config.js";
export default {
  props: ["options", "value", "full", "className"],
  data() {
    return {
      baseUrl: config.api.replace("/api/", ""),
    };
  },
  methods: {
    truncatedText(text, getText = true) {
      const maxLength = 100;
      if (text.length > maxLength) {
        return getText ? text.slice(0, maxLength) + "..." : true;
      } else {
        return getText ? text.slice(0, maxLength) + "..." : false;
      }
    },
    onSwitch(val) {
      if (this.full == 100) {
        this.$emit("input", this.value ? !val : val);
      } else {
        this.$emit("input", val);
      }
    },
  },
};
</script>

<style lang="scss">
.hide-variant {
      display: none !important;
}
.hover-variant {
  /*display: none;*/
  position: absolute;
  bottom: 50px;
  background-color: #203551;
  padding: 5px 10px;
  color: #fff;
  font-size: 10px;
  font-weight: 400;
  border-radius: 10px;
  z-index: -1;
  opacity: 0;
  transition: 0.3s ease;
  max-width: 100%;
  height: auto;
  white-space: break-spaces;
}
.switch-green-selected {
  position: relative;
  &:hover .hover-variant {
    display: block;
    bottom: 60px;
    opacity: 1;
    z-index: 99;
  }
  
  .disabled-option{
    background-color:#F6F8FC;
    color:#B1BBC9;
    opacity: 1;
    .b-simple__content__title{
      color: #B1BBC9 !important;
    }
  }
  .b-simple {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;

    box-sizing: border-box;
    cursor: pointer;
    text-align: center;
    position: relative;

    min-width: 67px;
    height: auto;
    min-height: 40px;
    padding: 11px 15px;



    border: 1px solid transparent !important;
    border-radius: 8px;

    &:before{
      content: "";
        position: absolute;
        inset: 0px;
        border: 2px solid #E0E9F4;
        border-radius: 8px;
    }

    &.active {
      box-shadow: none;
      border: 1px solid transparent !important;
      &:before{
        content: "";
        position: absolute;
        inset: 0px;
        border: 2px solid #2e47ba;
        border-radius: 8px;
      }
      .b-simple__content {
        .b-simple__content__title {
          color: #2e47ba;
        }
      }

      .b-simple__mark {
        position: absolute;
        top: -8px;
        right: 8px;
      }
    }

    .b-simple__content {
      .b-simple__content__title {
        color: #6c7e95;
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        line-height: 18px;
        letter-spacing: 0.28px;
        margin: 0;
        max-width: 100%;
        width: 100%;
        text-align: left;
        overflow-wrap: anywhere;
      }
    }
  }
}
.tuktukTheme .b-simple.active:before{   
    border: 1px solid #EB435B;
  
}
.tuktukTheme .b-simple.active .b-simple__content__title{   
    
}
.tuktukTheme .b-simple__mark{
  display: none;
}

.tuktukTheme.switch-green-selected {
  position: relative;
  &:hover .hover-variant {
    display: block;
    bottom: 60px;
    opacity: 1;
    z-index: 99;
  }
  
  .disabled-option{
    background-color:transparent;
    color: #15171C !important;
    opacity: 0.4;
    .b-simple__content__title{
      color: #15171C !important; 
    }
  }
  .b-simple {
    min-width: unset;
    height: auto;
    min-height: 40px;
    min-width: 60px;
    padding: 4px 8px;

    border: 1px solid transparent !important;
    border-radius: 4px;

    &:before{
      content: "";
        position: absolute;
        inset: 0px;
        border: 1px solid rgba(21, 23, 28, 0.10);
        border-radius: 4px;
    }

    &.active {
      box-shadow: none;
      border: 1px solid transparent !important;
      &:before{
        content: "";
        position: absolute;
        inset: 0px;
        border: 2px solid #EB435B;
        border-radius: 4px;
      }
      .b-simple__content {
        .b-simple__content__title {
          color: #EB435B;
        }
      }

      .b-simple__mark {
        display: none;
      }
    }

    .b-simple__content {
      .b-simple__content__title {
        color: #15171C;
        text-align: center;
        font-family: TikTokDisplayRegular;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 160%; /* 19.2px */
        letter-spacing: 0.24px;
      }
    }
  }
}
</style>
